module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAoUlEQVR42mOgPRgFo2D6/PUK05ds2g+iaWLBDJDhSzb+B+L7U5euN6C6Bf3z1wvMWLLxPNSS97SzZOmm9VBL/s9csiWeJsE1bcn6BTBLpi/dXE+bSF+8voGmlswEGgqzYCrQMuq6fumm+TDDgcFVQDWD5wMjeRpSJE9ftD6BioYjkum0xRvfA+PAgeoZDWb41PnrDWhUVGyAFxX0B6NgFAAAacx/5IAVyPQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/arrow_right.png
// module id = 140
// module chunks = 0 1 2 3 4 5 7